export default __webpack_public_path__ + "static/media/placeholder-gold-logo.d8b12316.svg";